import { getCommonCopy } from "@base/content";

/** Keyboard users jump past the header to the page's <main id="main-content">. */
export function SkipLink() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:rounded-md focus:bg-white focus:px-4 focus:py-2 focus:text-black focus:shadow-lg"
    >
      {getCommonCopy().skipLink}
    </a>
  );
}
